export const getResponsiveState = state => state.responsive;
